import React, { useState } from 'react';
import { Button, Header, Icon, Modal } from 'semantic-ui-react';

interface ConfirmModalProps {
  content: string;
  header: string;
  onConfirm: (closeModal: () => void) => void;
  onClose: () => void;
  buttonText: string;
}

export function ConfirmModal(props: ConfirmModalProps) {
  const [modalOpen, setModalOpen] = useState(false);

  const handleOpen = () => setModalOpen(true);
  const handleClose = () => {
    setModalOpen(false);
    props.onClose();
  };
  const handleConfirm = () => {
    const closeModal = () => setModalOpen(false);
    props.onConfirm(closeModal);
  };

  return (
    <>
      <Modal
        trigger={
          // <Button onClick={handleOpen} negative>
          //   {props.buttonText}
          // </Button>
          <Icon name="remove circle" onClick={handleOpen} color="red" size="large"></Icon>
        }
        open={modalOpen}
        onClose={handleClose}
        size="small"
      >
        <Header content={props.header} />
        <Modal.Content>
          <p>{props.content}</p>
        </Modal.Content>
        <Modal.Actions>
          <Button color="red" onClick={handleClose}>
            <Icon name="remove" /> No
          </Button>
          <Button color="green" onClick={handleConfirm}>
            <Icon name="checkmark" /> Yes
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
}
